import { render, staticRenderFns } from "./StaffPayrollModal.vue?vue&type=template&id=2fa597b2&"
import script from "./StaffPayrollModal.vue?vue&type=script&lang=js&"
export * from "./StaffPayrollModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports